import axios from 'axios'
import backendUrl from '../configback'
const local = `${backendUrl}`
const production = ''
const api = axios.create({
    baseURL: `${local}/api`,
    withCredentials : true
    
})
export default api